import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/navbar.css";
import krishtechlogo from "../images/krishtechlogo.jpg";
import kslogo from "../images/kslogo.jpg";

const Navbar = () => {
    return (
        <nav className="nav">
            <div className="text-company_header">
                <img className="small_logo" src={kslogo} alt="Logo" />
                <div>KrishTech Software</div>
            </div>
            <ul className="nav-list">
                <li>
                    <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>
                        Home
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/services" className={({ isActive }) => (isActive ? "active" : "")}>
                        Services
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")}>
                        About
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")}>
                        Contact Us
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;
